const timestampFields = {
  _seconds: Number,
  _nanoseconds: Number,
}

export default timestampFields
